import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=d05ee2a4&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=d05ee2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05ee2a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05ee2a4')) {
      api.createRecord('d05ee2a4', component.options)
    } else {
      api.reload('d05ee2a4', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=d05ee2a4&scoped=true&", function () {
      api.rerender('d05ee2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21E7LEyCdgPhK/JS/comp/CookieBox.vue"
export default component.exports